import { isFeedInstance } from './../models/feed';
import { BaiduUnionPromotionInstance } from './../models/apis/promotion';
import { FeedInstance } from 'src/models/feed';
/**
 * @see https://code.sohuno.com/sohu-media/spm-js
 * SohuSpm documents above.
 *
 * @summary SohuSpm helper utils.
 * @author MonkeyFigaro <monkeychen@sohu-inc.com>
 *
 * Created at     : 2019-04-17 10:43:23
 * Last modified  : 2019-09-03 18:34:39
 */

import { WindowWithManualSpm, WindowWithSpm } from 'src/models/sohuSpm';
import { PromotionInstance, XPSPromotionInstance } from 'src/models/apis/promotion';

/**
 * generate a 7 bytes random string.
 * the complexity of the random string is 52^7.
 */
export const genRands = () => {
    const rands = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const res = [0, 0, 0, 0, 0, 0, 0];
    return res.map(() => rands[Math.floor(Math.random() * rands.length)]).join('');
};

/**
 * This function returns ecode based on spm.
 * In some cases this function would create
 * a new window.sohuSpm entity which has only
 * one attribute `_eCode`.
 * @return {string} - spm ecode
 */
export const spmGetEcode = () => {
    const sohuSpmUtil = (window as unknown as WindowWithSpm).sohuSpm;
    // case 1: we have a true spm and just return its ecode by getCodes().
    if (sohuSpmUtil && typeof sohuSpmUtil.getCodes === 'function') {
        return sohuSpmUtil.getCodes().e;
    }
    // case 2: we have a `false` spm which we created earlier in case 3, we return its _eCode.
    // becase sohuSpm use _eCode to set ecode before its initialize.
    if ((window as unknown as WindowWithManualSpm).sohuSpm && (window as unknown as WindowWithManualSpm).sohuSpm._eCode) {
        return (window as unknown as WindowWithManualSpm).sohuSpm._eCode;
    }
    // case 3: no sohuspm exists, and we must create a new spm, then set its ecode.
    (window as unknown as WindowWithManualSpm).sohuSpm = (window as unknown as WindowWithManualSpm).sohuSpm || {};
    const ecode = `${new Date().getTime()}${genRands()}`;
    (window as unknown as WindowWithManualSpm).sohuSpm._eCode = ecode;
    return ecode;
};

export const spmGetCodesStr = (): string => {
    if ((window as unknown as WindowWithSpm).sohuSpm && typeof (window as unknown as WindowWithSpm).sohuSpm.getCodes === 'function') {
        const { a, b, c, d, e } = (window as unknown as WindowWithSpm).sohuSpm.getCodes();
        return [a, b, c, d, e].join(',');
    }
    return [0, 0, 0, 0, 0].join(',');
};

/**
 * @param  {string} target
 */
export const domDidChange = (target?: string) => {
    const sohuSpmUtil = (window as unknown as WindowWithSpm).sohuSpm;
    if (sohuSpmUtil && typeof sohuSpmUtil.domDidChange === 'function') {
        if (target) {
            sohuSpmUtil.domDidChange({ target });
        } else {
            sohuSpmUtil.domDidChange();
        }
    }
};

/**
 * @param  {string} target
 */
export const spmRescan = () => {
    const sohuSpmUtil = (window as unknown as WindowWithSpm).sohuSpm;
    if (sohuSpmUtil && typeof sohuSpmUtil.domDidChange === 'function') {
        sohuSpmUtil.reScan();
    }
};

/**
 * Beware that it might return empty strings when we didn't get spm.
 * I do not want to write functions to get a/b/eCode again, because
 * that's what spm should do for us. Naughty me ;)
 *
 * @returns {string} - spm codes
 */
export const spmGetParams = () => {
    const sohuSpmUtil = (window as unknown as WindowWithSpm).sohuSpm;
    if (!sohuSpmUtil.getCodes || typeof sohuSpmUtil.getCodes !== 'function') {
        return '';
    }
    const { a, b, c, d, e } = sohuSpmUtil.getCodes();
    return [a, b, c, d, e].join('.');
};

export const genPCMCode = (ins: FeedInstance | PromotionInstance | XPSPromotionInstance | BaiduUnionPromotionInstance):string => {
    const resourceType = ins.resourceType || '';
    const mediaId = isFeedInstance(ins) ? ins.authorId || '' : '';
    const contentId = ins.id || '';
    const PCM = ins.pcm || '';
    const contentType = ins.type || '';
    const adInfo = '';
    return [
        resourceType,
        mediaId,
        contentId,
        PCM,
        contentType,
        adInfo,
    ].join('|');
};



// WEBPACK FOOTER //
// ./src/utils/spmHelper.ts